import React, {Fragment, useState} from "react";
import {createStyles, makeStyles} from "@material-ui/core/styles";
import {Badge, IconButton} from "@material-ui/core";
import { Forum } from "@material-ui/icons";
import MessagesDrawer from "./MessagesDrawer";
import { useMfwThemeProvider } from "myfitworld-utils";
import { useMessagesProvider } from "src/providers/MessagesProvider";

const useStyles = makeStyles(() =>
  createStyles({
    notification: {
      color: "white",
    },
  })
);
const MessageButton = () => {
  const classes = useStyles();
  const theme = useMfwThemeProvider();
  const [isOpen, setOpen] = useState(false);
  const {unreadCountMessages} = useMessagesProvider();
  const handleNotifications = () => {
    setOpen((prevState) => !prevState);
  };
  return (
    <Fragment>
      <IconButton onClick={handleNotifications}>
        <Badge  badgeContent={unreadCountMessages} color="error">
          <Forum style={{color:theme.mfwMuiWebTheme.palette.text.primary}} className={classes.notification}/>
        </Badge>
      </IconButton>
      {isOpen && <MessagesDrawer isOpen={isOpen} onClose={handleNotifications}/>}
    </Fragment>
  );
};

export default MessageButton;
